import type { RSUAsset, ShareAsset } from "~/types/assets.types";
import { calculateRSUShareProfitRate, calculateShareProfitRate } from "./profit";
import { calculateRSUsYears, calculateStocksYears } from "./years";

export const calculateShareYearlyYield = (userProduct: ShareAsset) => {
  const stocks = userProduct?.stocksData || [];
  const shareProfitRates = calculateShareProfitRate(userProduct);
  const stockYears = calculateStocksYears(userProduct);

  return stocks.map((_, index) => {
    const shareProfitRate = shareProfitRates?.[index] || 0;
    const years = stockYears?.[index] || 0;

    if (Number(years) === 0) return 0;
    return shareProfitRate / years;
  });
};


export const calculateRSUsYearlyYield = (userProduct: RSUAsset) => {
  const stocks = userProduct?.rsuData || [];
  const shareProfitRates = calculateRSUShareProfitRate(userProduct);
  const stockYears = calculateRSUsYears(userProduct);

  return stocks.map((_, index) => {
    const shareProfitRate = shareProfitRates?.[index] || 0;
    const years = stockYears?.[index] || 0;

    if (Number(years) === 0) return 0;
    return shareProfitRate / years;
  });
};
